// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sj-5";
export var filledCircle = "_sj-4";
export var historyEntry = "_sj-3";
export var messageSideLeft = "_sj-1";
export var messageSideRight = "_sj-2";
export var orderTrackingCarouselWrapper = "_sj-6";
export var orderTrackingInfoContainer = "_sj-0";